<div class="role-details-wrapper">
  <!-- ========================= -->
  <!-- ROLE DETAILS CARD -->
  <!-- ========================= -->
  <div class="card role-details-card">
    <!-- ROLE NAME + COLOR -->
    <div class="row-grid">
      <!-- Role Name -->
      <div>
        <wm-common-text
          [data]="{ text: 'Role Name' }"
          class="label"
        ></wm-common-text>

        <input type="text" class="text-input" [(ngModel)]="role.name" />
      </div>

      <!-- Role Color -->
      <div>
        <wm-common-text
          [data]="{ text: 'Role Color' }"
          class="label"
        ></wm-common-text>

        <div class="color-row">
          <select class="text-input" [(ngModel)]="role.color">
            <option [ngValue]="null" disabled>
              Role Color
            </option>

            <option *ngFor="let c of colorOptions" [ngValue]="c.value">
              {{ c.name }}
            </option>
          </select>

          <div
            class="color-preview-box"
            [ngClass]="role.color ? 'rc-' + role.color : 'rc-empty'"
          ></div>
        </div>
      </div>
    </div>

    <!-- ROLE MEMBERS -->
    <div class="row-grid">
      <!-- LEFT COLUMN -->
      <div>
        <wm-common-text
          [data]="{ text: 'Role Members' }"
          class="label"
        ></wm-common-text>

        <div class="add-member-wrapper">
          <mat-form-field appearance="outline" class="add-member-field">
            <input
              matInput
              placeholder="Add member to role"
              [formControl]="memberCtrl"
              [matAutocomplete]="auto"
            />

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayMember"
              (optionSelected)="onMemberSelected($event.option.value)"
              class="role-autocomplete-panel"
            >
              <mat-option *ngFor="let u of memberSearchResults" [value]="u">
                <div class="member-name">{{ u.name }}</div>
                <div class="member-email">{{ u.email }}</div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <button
            class="add-btn"
            [disabled]="!selectedMember"
            (click)="addMember()"
          >
            ADD
          </button>
        </div>
      </div>

      <!-- RIGHT COLUMN EMPTY (for alignment with Role Color) -->
      <div></div>
    </div>

    <!-- MEMBERS LIST -->
    <!-- MEMBERS LIST -->
    <div *ngIf="role.members.length; else noMembers">
      <div class="members-grid">
        <div class="member-row" *ngFor="let m of role.members">
          <div>{{ m.name }}</div>
          <div>{{ m.email }}</div>
          <wm-common-icon
            [data]="{ iconName: deleteIcon }"
            class="delete-icon"
            (click)="removeMember(m.id)"
          ></wm-common-icon>
        </div>
      </div>
    </div>

    <!-- EMPTY STATE -->
    <ng-template #noMembers>
      <div class="empty-members">
        <wm-common-text
          [data]="{ text: 'No members added to this role yet.' }"
          class="empty-text"
        ></wm-common-text>
      </div>
    </ng-template>
  </div>

  <!-- ========================= -->
  <!-- PERMISSIONS -->
  <!-- ========================= -->
  <div class="card permissions-card">
    <div class="perm-header" (click)="togglePermissions()">
      <wm-common-text
        [data]="{ text: 'Role Permissions' }"
        class="label"
      ></wm-common-text>
      <mat-icon class="expand" [class.rotate]="isPermissionsOpen">
        expand_more
      </mat-icon>
    </div>

    <div class="perm-body" [class.open]="isPermissionsOpen">
      <div class="select-all">
        <input
          type="checkbox"
          [checked]="role.permissions.length === allPermissions.length"
          (change)="toggleAllPermissions($event)"
        />
        <wm-common-text [data]="{ text: 'Select All' }"></wm-common-text>
      </div>

      <div class="permissions-grid">
        <div class="perm-item" *ngFor="let p of allPermissions">
          <input
            type="checkbox"
            [checked]="isChecked(p.id)"
            (change)="togglePermission(p.id)"
          />
          <span>{{ p.name }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================= -->
  <!-- ROLE DEPENDENCIES (DELETE BLOCKER) -->
  <!-- ========================= -->
  <div class="card permissions-card" *ngIf="!loadingDeleteInfo && !canDelete">
    <div class="perm-header" (click)="toggleDeleteInfo()">
      <wm-common-text
        [data]="{ text: 'Role Dependencies' }"
        class="label"
      ></wm-common-text>

      <mat-icon class="expand" [class.rotate]="isDeleteInfoOpen">
        expand_more
      </mat-icon>
    </div>

    <div class="perm-body open" *ngIf="isDeleteInfoOpen">
      <wm-common-text
        [data]="{
          text:
            'This role cannot be deleted because it is used in the following areas:'
        }"
        class="dependency-text"
      ></wm-common-text>

      <ul class="dependency-list">
        <li *ngFor="let w of occupiedWorkflows">
          <wm-common-text [data]="{ text: w }"></wm-common-text>
        </li>

        <li *ngFor="let a of adminWorkflows">
          <wm-common-text [data]="{ text: a }"></wm-common-text>
        </li>
      </ul>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="action-footer">
    <button class="close-btn" (click)="close.emit()">Close</button>
    <button class="btn-delete" [disabled]="!canDelete"  (click)="openDeleteConfirm()">
      Delete
    </button>
    <button class="btn-save" (click)="save.emit()">Save</button>
  </div>
</div>
<!--<wm-common-confirmation-modal
  [data]="confirmationModal"
  (onYesClick)="onConfirmRemove()"
  (onNoClick)="closeModal()"
  (onOkClick)="closeModal()"
  (onCloseClick)="closeModal()"
></wm-common-confirmation-modal>
<wm-common-confirmation-modal
  [data]="confirmationModal"
  (onYesClick)="onConfirmDelete()"
  (onNoClick)="closeDeleteModal()"
  (onOkClick)="closeDeleteModal()"
  (onCloseClick)="closeDeleteModal()"
></wm-common-confirmation-modal>-->
<wm-common-confirmation-modal
  [data]="confirmationModal"
  (onYesClick)="handleModalConfirm()"
  (onNoClick)="closeModal()"
  (onOkClick)="closeModal()"
  (onCloseClick)="closeModal()"
  [isApplicantMobileview]="true"
></wm-common-confirmation-modal>

